var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./TrackingNotifier.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4dbd049d\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./TrackingNotifier.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TrackingNotifier/TrackingNotifier.vue
// module id = 74
// module chunks = 1